import { render } from "./Config.vue?vue&type=template&id=9ba5946c&scoped=true&ts=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=9ba5946c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba5946c"]])

export default __exports__